import { configureStore } from '@reduxjs/toolkit'
import objectiveSlice from '../domains/Objectives/store/objective.slice'
import authSlice from '../domains/Login/store/auth.slice'
import vocabularySlice from '../domains/Translations/store/vocabulary.slice'
import linkSlice from '../domains/Notes/Links/store/link.slice'
import locationSlice from '../domains/Notes/Locations/store/location.slice'
import eventSlice from '../domains/Events/store/event.slice'
import toDoSlice from '../domains/Notes/ToDoes/store/toDo.slice'
import memorySlice from '../domains/Notes/Memories/store/memory.slice'
import ideaSlice from '../domains/Notes/Ideas/store/idea.slice'
import whiteboardSlice from '../domains/Whiteboard/store/whiteboard.slice'
import recipeSlice from '../domains/Notes/Recipe/store/recipe.slice'
import movieSlice from '../domains/Notes/Movies/store/movie.slice'
import tripSlice from '../domains/Notes/Trips/store/trip.slice'
import purchaseListSlice from '../domains/Purchase/store/purchase.slice'
import filesSlice from '../domains/Files/store/files.slice'
import weddingSlice from '../domains/wedding/store/wedding.slice'
import scenarioSlice from '../domains/Scenarios/store/scenario.slice'
import mainSlice from './main.slice'

const store = configureStore({
  reducer: {
    main: mainSlice,
    objective: objectiveSlice,
    auth: authSlice,
    toDo: toDoSlice,
    memory: memorySlice,
    idea: ideaSlice,
    vocabulary: vocabularySlice,
    link: linkSlice,
    location: locationSlice,
    event: eventSlice,
    whiteboard: whiteboardSlice,
    recipe: recipeSlice,
    movie: movieSlice,
    trip: tripSlice,
    purchaseList: purchaseListSlice,
    file: filesSlice,
    wedding: weddingSlice,
    scenario: scenarioSlice,
  },
})

if (typeof window !== 'undefined') {
  ;(
    window as Window & {
      __IVA_STORE__?: typeof store
    }
  ).__IVA_STORE__ = store
}

export type RootState = ReturnType<typeof store.getState>

export default store
